import { cx } from "../../lib/cx.js";
import { useFormFieldControl } from "../FormField/FormFieldContext.js";
/* empty css             */
import { forwardRef, useCallback, useLayoutEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Textarea/Textarea.tsx
var supportsFieldSizing = () => typeof CSS !== "undefined" && typeof CSS.supports === "function" && CSS.supports("field-sizing", "content");
/** Where `field-sizing: content` isn't supported: sets the height to fit the content. */
function fitContent(element) {
	element.style.height = "auto";
	const { borderTopWidth, borderBottomWidth } = getComputedStyle(element);
	const borders = (parseFloat(borderTopWidth) || 0) + (parseFloat(borderBottomWidth) || 0);
	element.style.height = `${element.scrollHeight + borders}px`;
}
function setRef(ref, value) {
	if (typeof ref === "function") ref(value);
	else if (ref) ref.current = value;
}
/**
* A multi-line text input, styled like Input: a native `<textarea>` that resizes
* vertically. `className`, every other prop and the ref go to the `<textarea>`.
*/
var Textarea = forwardRef(function Textarea({ size = "md", rows = 4, autoResize = false, invalid: invalidProp, className, id: idProp, "aria-describedby": describedByProp, onInput, value, style, ...rest }, ref) {
	const { id, "aria-describedby": describedBy, invalid } = useFormFieldControl({
		id: idProp,
		"aria-describedby": describedByProp,
		invalid: invalidProp
	});
	const element = useRef(null);
	const setElement = useCallback((node) => {
		element.current = node;
		setRef(ref, node);
	}, [ref]);
	const needsFallback = autoResize && !supportsFieldSizing();
	useLayoutEffect(() => {
		if (needsFallback && element.current) fitContent(element.current);
	}, [needsFallback, value]);
	const handleInput = (event) => {
		onInput?.(event);
		if (needsFallback) fitContent(event.currentTarget);
	};
	return /* @__PURE__ */ jsx("textarea", {
		ref: setElement,
		className: cx("ds-textarea", `ds-textarea--${size}`, autoResize && "ds-textarea--auto-resize", className),
		style: {
			"--_rows": rows,
			...style
		},
		id,
		rows,
		"aria-invalid": invalid || void 0,
		"aria-describedby": describedBy,
		value,
		onInput: handleInput,
		...rest
	});
});
//#endregion
export { Textarea };

//# sourceMappingURL=Textarea.js.map